<template>
  <button
    id="dropdown-option"
    data-testid="dropdown-option"
    class="dropdown-option__button"
    @click="handleClick"
    @keydown.enter="handleClick"
  >
    <div class="dropdown-option__button__inner">
      <img
        v-if="hasImage"
        :src="data.image.small"
        alt=""
        data-testid="dropdown-option-image"
      />
      <BaseText size="lg" :color="NebraskaColors.textPrimary">
        {{ data.description }}
      </BaseText>
    </div>
  </button>
</template>

<script lang="ts">
import { Component, Prop, Vue } from 'vue-property-decorator';

import { BaseText } from '@warrenbrasil/nebraska-web';

import { SuggestedInstrument } from '@/modules/trade/services/search';
import { NebraskaColors } from '@warrenbrasil/nebraska-tokens-web';

@Component({
  components: {
    BaseText
  }
})
export default class DropdownOptionItem extends Vue {
  @Prop({ type: Object, required: true })
  private data!: SuggestedInstrument;

  private NebraskaColors = NebraskaColors;

  private get hasImage() {
    return Boolean(this.data.image);
  }

  private handleClick() {
    this.$emit('option-click', this.data);
  }
}
</script>

<style lang="less" scoped>
.dropdown-option {
  &__button {
    background: @background-secondary;
    padding: 0px @size-spacing-x300;
    width: 100%;
    border-radius: 8px;

    &:hover,
    &:focus {
      background: @background-hover;
      outline: none;
    }

    &__inner {
      display: flex;
      align-items: center;
      padding: @size-spacing-x350 0px;
      width: 100%;
      img {
        width: 24px;
        height: 24px;
        border-radius: 12px;
        margin-right: @size-spacing-x400;
      }
      svg {
        margin-right: @size-spacing-x400;
      }
    }
  }
}
</style>
